import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Prism from 'prismjs';
import 'prismjs/plugins/autoloader/prism-autoloader';

(Prism as any).plugins.autoloader.languages_path = '/assets/prism-languages/';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
